import { Box, ButtonProps, Button as MuiButton } from '@material-ui/core';

import React from 'react';

/**
 * A trivial example of extending a Material UI component.
 * Extend the Material UI props with a new prop `offsetAmount`
 * @example
 * `<Button offsetAmount={2} size="small">`
 */
interface Props extends ButtonProps {
  offsetAmount?: number; // theme units, i.e., 1 = 8px
}
// Name this component the same as Material UI's so devs know they can still go look at the official docs
const Button = React.forwardRef<HTMLButtonElement, Props>(
  (props: Props, ref) => {
    // Grab the custom prop, everything else gets passed to the Material UI component
    const { offsetAmount, ...buttonProps } = props;

    // Do validation, computation, setting defaults of custom props here if necessary.

    return offsetAmount ? (
      <Box m={offsetAmount}>
        <MuiButton ref={ref} {...buttonProps} />
      </Box>
    ) : (
      <MuiButton ref={ref} {...buttonProps} />
    );
  },
);

export default Button;
